( () => {
	const allSearchWrappers   = Array.from( document.querySelectorAll( '.searchform' ) );

	allSearchWrappers.forEach( ( searchWrapper ) => {
		const searchInput   = searchWrapper?.querySelector<HTMLInputElement>( 'input[data-type="search"]' );
		const clearInputBtn = searchWrapper?.querySelector<HTMLButtonElement>( 'button[data-type="searchinput-clearbtn"]' );

		if ( searchInput ) searchInput.value = '';

		searchInput?.addEventListener( 'input', () => {
			if ( searchInput.value.length === 0 )
				return clearInputBtn.dataset.show = 'false';
			return clearInputBtn.dataset.show = 'true';
		} );

		clearInputBtn?.addEventListener( 'click', () => {
			searchInput.value = '';
			searchInput.focus( {} );
			clearInputBtn.dataset.show='false';
			searchInput.dispatchEvent( new InputEvent( 'input', { bubbles: true } ) );
		} );
	} );
} )();
